import { apiToastError } from '@/@core/utils/toast'

// Credits errors are handled by the axios interceptor (shows the API message).
// Non-Credits errors show a user-friendly fallback instead.
export function handleErrorToast(err, fallback = 'Something went wrong, please try again later.') {
  if (!err?.response?.data?.message?.includes('Credits')) {
    apiToastError(fallback)
  }
}
